import { Box, styled } from '@mui/material';

export const FocusModeButton = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'absolute',
	top: '8vh',
	height: '24px',
	width: '24px',
	zIndex: '1000',
	border: '2px solid #4786FF',
	borderRadius: '8px',
	cursor: 'pointer',
	backgroundColor: '#FFFFFF',
	pointerEvents: 'auto',
	'&:hover': {
		backgroundColor: '#DAE7FF',
	},
	'&:active': {
		transform: 'scale(0.95)',
	},
});
